import VueRouter from 'vue-router';
import { __ } from './helpers';

import Campaigns from './views/campaigns/Index.vue';
import Celebrities from './views/celebrities/Index.vue';
import CelebrityCampaigns from './views/celebrity-campaigns/Index';
import Dashboard from './views/Dashboard.vue';
import Events from './views/events/Index';
import EventsCreate from './views/events/Create';
import EventsEdit from './views/events/Edit';
import Login from './views/auth/Login.vue';
import Logout from './views/auth/Logout.vue';
import News from './views/news/Index.vue';
import NewsCreate from './views/news/Create.vue';
import NewsEdit from './views/news/Edit.vue';
import Participants from './views/events/Participants';
import Programs from './views/programs/Index.vue';
import ProgramsCreate from './views/programs/Create.vue';
import ProgramsEdit from './views/programs/Edit.vue';
import Users from './views/users/Index.vue';
import Videos from './views/videos/Index.vue';
import NewsletterIndex from './views/newsletter/Index.vue';
import OrganizerIndex from './views/organizers/Index.vue';
import OrganizerEdit from './views/organizers/Edit.vue';

const routes = [
    {
        name: 'dashboard',
        path: '/dashboard',
        component: Dashboard,
        meta: {
            title: __('Dashboard')
        }
    },

    {
        name: 'campaigns',
        path: '/campaigns',
        component: Campaigns,
        meta: {
            title: __('Campaigns')
        }
    },

    {
        name: 'login',
        path: '/',
        component: Login,
        meta: {
            title: __('Login')
        }
    },

    {
        name: 'logout',
        path: '/logout',
        component: Logout,
        meta: {
            title: __('Logout')
        }
    },

    {
        name: 'news',
        path: '/news',
        component: News,
        meta: {
            title: __('News')
        }
    },
    {
        name: 'news.create',
        path: '/news/create',
        component: NewsCreate,
        meta: {
            title: __('Add news')
        }
    },
    {
        name: 'news.show',
        path: '/news/:id/edit',
        component: NewsEdit,
        meta: {
            title: __('Edit news')
        }
    },

    {
        name: 'programs',
        path: '/programs',
        component: Programs,
        meta: {
            title: __('Programs')
        }
    },
    {
        name: 'programs.create',
        path: '/programs/create',
        component: ProgramsCreate,
        meta: {
            title: __('Add program')
        }
    },
    {
        name: 'programs.show',
        path: '/programs/:id/edit',
        component: ProgramsEdit,
        meta: {
            title: __('Edit program')
        }
    },

    {
        name: 'users',
        path: '/users',
        component: Users,
        meta: {
            title: __('Users')
        }
    },

    {
        name: 'videos',
        path: '/videos',
        component: Videos,
        meta: {
            title: __('Frontpage videos')
        }
    },
    {
        name: 'events',
        path: '/events',
        component: Events,
        meta: {
            title: __('Events')
        }
    },
    {
        name: 'events',
        path: '/events/create',
        component: EventsCreate,
        meta: {
            title: __('Add event')
        }
    },
    {
        name: 'events',
        path: '/events/:id/edit',
        component: EventsEdit,
        meta: {
            title: __('Edit event')
        }
    },
    {
        name: 'events-participants',
        path: '/events/:id/participants',
        component: Participants,
        meta: {
            title: __('Participants')
        }
    },
    {
        name: 'celebrities',
        path: '/celebrities',
        component: Celebrities,
        meta: {
            title: __('Celebrities')
        }
    },
    {
        name: 'celebrity-campaigns',
        path: '/celebrity-campaigns',
        component: CelebrityCampaigns,
        meta: {
            title: __('Celebrity Campaigns')
        }
    },
    {
        name: 'newsletters',
        path: '/newsletters',
        component: NewsletterIndex,
        meta: {
            title: __('Newsletters')
        }
    },
    {
        name: 'organizers',
        path: '/organizers',
        component: OrganizerIndex,
        meta: {
            title: __('Organizers'),
        }
    },
    {
        name: 'organizers',
        path: '/organizers/:id/edit',
        component: OrganizerEdit,
        meta: {
            title: __('Organizer Edit'),
        }
    },
];

export default new VueRouter({
    base: process.env.BASE_URL,
    routes: routes
});
